import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames';

import { formsV2 as Forms, buttonsV2 as Buttons } from '@breezeway/brzw-components';
import { task as taskCore } from '@breezeway/brzw-react-core';
import { getAvatarFromPerson, personName } from '../../utils/people_helpers';
import { DEPARTMENT_NAMES } from '../../utils/departments';

const CLASS_NAME = 'smart_assignment_select';

const getSections = department => ({
  recommended: 'Suggested',
  department: _.get(DEPARTMENT_NAMES, department),
  all: 'All',
});

export class SmartAssignmentSelect extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      areAssigneesFetching: true,
      isDropdownOpened: false,
      recommendedOptions: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { config } = this.props;
    if (!_.isEqual(prevProps.config, config)) {
      this.resetRecommendAssignees();
    }
  }

  onDropdownToggle = isDropdownOpened =>
    this.setState({
      isDropdownOpened,
    });

  onFetchAssigneesSuccess = data => {
    const { config } = this.props;
    const department = _.get(config, 'type_department');
    const options = _.map(getSections(department), (section, key) =>
      _.map(_.get(data, key), option => {
        const person = _.get(option, 'company_person');

        return {
          avatar: getAvatarFromPerson(person),
          group: section,
          info: _.get(option, 'reason.name'),
          label: personName(person),
          value: _.get(person, 'id'),
        };
      }),
    );

    this.setState({
      areAssigneesFetching: false,
      recommendedOptions: _.concat(...options),
    });
  };

  onFetchAssigneesFailure = () => {
    this.setState({
      areAssigneesFetching: false,
    });
  };

  onSelectAssignee = id => {
    const { value, onChange } = this.props;

    setTimeout(() => {
      onChange([...value, id]);
      this.resetRecommendAssignees();
    });
  };

  fetchRecommendAssignees = () => {
    const { config, getRecommendAssignees, value } = this.props;

    getRecommendAssignees(
      {
        ...config,
        exclude_company_people_ids: value,
      },
      this.onFetchAssigneesSuccess,
      this.onFetchAssigneesFailure,
    );
  };

  resetRecommendAssignees = () =>
    this.setState({
      areAssigneesFetching: true,
      recommendedOptions: [],
    });

  render() {
    const { className, disabled, value } = this.props;
    const { areAssigneesFetching, isDropdownOpened, recommendedOptions } = this.state;

    return (
      <Forms.Select
        className={classnames(CLASS_NAME, className)}
        closeDropdownAfterSelect
        disabled={disabled}
        iconBefore="search"
        id="smart-assignment-select"
        onDropdownToggle={this.onDropdownToggle}
        onSelect={this.onSelectAssignee}
        options={recommendedOptions}
        optionVariant="assignment"
        placeholderText="Search"
        searchable
        shouldFilterByGroups
        shouldShowSkeletons={areAssigneesFetching}
        shouldSortOptions={false}
        theme="subtle"
        value={value}
      >
        <Buttons.IconTextButton
          active={isDropdownOpened}
          className={`${CLASS_NAME}__add`}
          disabled={disabled}
          iconNameLeft="plus"
          onClick={this.fetchRecommendAssignees}
          size="medium"
          theme="subtle"
          withoutAction
        >
          Add assignee
        </Buttons.IconTextButton>
      </Forms.Select>
    );
  }
}

SmartAssignmentSelect.propTypes = {
  className: PropTypes.string,
  config: PropTypes.shape({
    type_department: PropTypes.string.isRequired,
    home_id: PropTypes.number,
    setting_task_template_id: PropTypes.number,
    task_id: PropTypes.number,
  }),
  disabled: PropTypes.bool,
  getRecommendAssignees: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.array,
};

export default connect(
  null,
  {
    getRecommendAssignees: taskCore.actionsV5.getRecommendAssignees,
  },
)(SmartAssignmentSelect);
